
import WAvatar from "@/components/data-display/WAvatar.vue";
import WBadge from "@/components/data-display/WBadge.vue";
import WIconWithBadge from "@/components/data-display/WIconWithBadge.vue";
import IconChat from "@/components/icons/IconChat";
import IconFavorite from "@/components/icons/IconFavorite";
import IconHome from "@/components/icons/IconHome";
import IconModel from "@/components/icons/IconModel";
import IconNotification from "@/components/icons/IconNotification";
import IconShoppingBag from "@/components/icons/IconShoppingBag";
import IconShoppingCart from "@/components/icons/IconShoppingCart";
import ComponentReflecter from "@/components/util/ComponentReflecter.vue";
import WButton from "@/components/actions/WButton.vue";

import { defineComponent } from "vue";

export default defineComponent({
  data() {
    return {
      shapes: ["rounded-full", "rounded", "rounded-none"],
      badge: WBadge,
      count: 0,
    };
  },
  components: {
    WBadge,
    ComponentReflecter,
    WAvatar,
    IconNotification,
    WIconWithBadge,
    IconHome,
    IconChat,
    IconShoppingBag,
    IconFavorite,
    IconShoppingCart,
    IconModel,
    "w-btn": WButton,
  },
});
